import React from "react";

const FooterWrapper = () => {
  return (
    <div style={{ padding: "12px 0 12px 48px" }}>
      Copyright Admin @ {new Date().getFullYear()} All Right Reserved
    </div>
  );
};

export default FooterWrapper;
